import { v5 as uuidv5 } from 'uuid';

const NS: string = uuidv5('FOTOCLASS:design-spread-preview@v1', uuidv5.URL);

export type DesignPreviewSize = 'large' | 'medium' | 'thumb';

/**
 * Stable storage id for a design spread's uploaded preview, derived from the package + spread + size.
 * The same edit always resolves to the same id, so a re-upload overwrites the object in place
 * instead of leaking a new file on every design change.
 */
export function designSpreadPreviewFileId(designPackageId: string, spreadId: string, size: DesignPreviewSize): string {
  return uuidv5(`${designPackageId}:${spreadId}:${size}`, NS);
}

// previews land in the pack's own file pool, and an untagged file is classified by name — without the
// workspace-wide `_preview` marker a generated capture is served back to the user as decor content
export function designSpreadPreviewFileName(fileId: string, extension: string): string {
  return `${fileId}_preview.${extension}`;
}
